import React, { Fragment } from 'react';
// Portr SDK - api class and methods
import PortrSDK from 'portr-javascript-sdk';
const portrSDK = new PortrSDK();
// services
import GATrackingService from '../../services/ga-tracking.service';
// styles
const styles = require('./bag-tags.scss');
// const API_PATH = process.env.REACT_APP_API_URL;


interface IState {
  showOverlay: boolean;
  overlayClasses: string;
  checkedBags: Array<any>;
  repatBags: Array<any>;
  bookingRef: string;
}

interface IProps {
  checkedBags: Array<any>;
  repatBags: Array<any>;
  bookingRef: any;
  language: string;
  multiLang: any;
}


class BagTagComponent extends React.Component<IProps, IState> {

  public barcodeOptions: any;
  public gaService = null;

  constructor(props: IProps) {
    super(props);

    this.state = {
      showOverlay: false,
      overlayClasses: styles.overlay,
      checkedBags: props.checkedBags,
      repatBags: props.repatBags,
      bookingRef: props.bookingRef
    }

    this.barcodeOptions = {
      width: 2,
      height: 80,
      format: 'ITF',
      font: 'Muli',
      textMargin: 6,
      fontSize: 18,
      margin: 0,
      marginLeft: 6,
      marginRight: 6
    }
  }

  componentDidMount() {
    this.state.checkedBags.forEach((item, index) => {
      portrSDK.generateBarcode('barcode' + index, item.iataCode, this.barcodeOptions);
    });
  }

  handleClick(val) {
    this.setState({ showOverlay: val });
    if (val) {
      this.setState({ overlayClasses: styles.overlay + ' ' + styles.fadeIn });
      document.getElementsByTagName('body')[0].classList.add(styles.bodyFixed);
      this.gaService = new GATrackingService(null, null, 'Track', 'View Bag Tags', this.state.bookingRef);
      this.gaService.sendHitView();
    } else {
      this.setState({ overlayClasses: styles.overlay + ' ' + styles.fadeOut });
      document.getElementsByTagName('body')[0].classList.remove(styles.bodyFixed);
    }
  }

  public render() {
    const { multiLang, language } = this.props;

    const showBags = (bags) => {

      const barcodeArr = bags.map((item, index) => {
        return (
          <div className={styles.card} key={index}>
            <div className={styles.cardHeader}>
              <h3>{multiLang[`bagText${language}`]} {index + 1} {multiLang[`ofText${language}`]} {bags.length}</h3>
            </div>
            {item.passengerLuggageImageURLs.length > 0
              ? <div className={styles.bagsContainer}>
                <div className={styles.bagImg}>
                  <img src={item.passengerLuggageImageURLs[0]} />
                </div>
              </div>
              : <div className={styles.barcodeContainer}>
                {multiLang[`noImageFoundForBag${language}`]}
              </div>
            }
            {item.iataCode !== ''
              ? <div className={styles.barcodeContainer}>
                <div id={'barcode' + index} className={styles.barcodeWrapper}></div>
              </div>
              : null
            }
          </div>
        )
      });
      return barcodeArr;
    }

    return (
      <Fragment>
        <button className={styles.btnInfoText} onClick={e => this.handleClick(true)}>{multiLang[`viewbagTagsButton${language}`]}</button>
        <div className={this.state.overlayClasses}>
          <div className={styles.scrollContainer}>
            <button className={styles.btnClose} onClick={e => this.handleClick(false)}>
              {multiLang[`closeText${language}`]}
              <i className={styles.icon}>close</i>
            </button>

            {this.state.checkedBags.length > 0
              ? <div className={styles.section}>
                <h2>{multiLang[`luggageCheckedInText${language}`]}</h2>
                {showBags(this.state.checkedBags)}
              </div>
              : null
            }

            {this.state.repatBags.length > 0
              ? <div className={styles.section}>
                <h2>{multiLang[`luggageHandedToText${language}`]}</h2>
                {showBags(this.state.repatBags)}
              </div>
              : null
            }
          </div>
        </div>
      </Fragment>
    );
  }

}

export default BagTagComponent;



// WEBPACK FOOTER //
// ./src/components/bag-tags/bag-tags.component.tsx